import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export var useMessages = function useMessages(locale, loaderFn) {
  var _useState = useState({
      locale: 'en',
      messages: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    localeState = _useState2[0],
    setLocaleState = _useState2[1];
  useEffect(function () {
    if (!localeState.messages || locale !== localeState.locale) {
      var current = true;
      loaderFn(locale).then(function (messages) {
        if (current) {
          setLocaleState({
            locale: locale,
            messages: messages !== null && messages !== void 0 ? messages : {}
          });
        }
      });
      return function () {
        current = false;
      };
    }
  }, [loaderFn, locale, localeState]);
  return localeState.messages;
};